import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { CoreService } from './core.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuardAdminService implements CanActivate {
  constructor(private core: CoreService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return (
      this.core.services.oauth.isAuthenticated() &&
      this.core.services.user.hasOneOfTheRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])
    )
  }
}
